






import { mqqShare, wechatShare, getUserAgent, delParam } from '@tencent/midas-util'
import Vue from 'vue'

export default Vue.extend({
  name: 'App',

  beforeRouteEnter() {
    window.addEventListener('pageshow', e => {
      if (e.persisted) {
        window.location.reload()
      }
    })
  },

  mounted() {
    this.initShare()
  },

  methods: {
    initShare() {
      const shareInfo = {
        title: '福利专区',
        desc: '腾讯充值的劲爆福利等你来抢'
      }

      // 获得分享的链接，避免链接上登录态外传
      function getShareUrl() {
        return delParam(['openid', 'openkey', 'sessionid', 'sessiontype', 'code'], window.location.href)
      }

      // 获得分享的查询信息接口
      function getWxShareInfo() {
        return {
          imgUrl: 'https://midas.gtimg.cn/h5pay/images/logo.png',
          imgWidth: 64,
          imgHeight: 64,
          link: getShareUrl(),
          appmessageTitle: shareInfo.title,
          appmessageDesc: shareInfo.desc,
          timelineTitle: shareInfo.title
        }
      }

      // 获得 QQ 分享的查询信息接口
      function getQQShareInfo(type) {
        return {
          share_type: type,
          title: shareInfo.title,
          desc: shareInfo.desc,
          share_url: getShareUrl(),
          image_url: 'https://midas.gtimg.cn/h5pay/images/logo.png'
        }
      }

      const ua = getUserAgent()

      if (ua.weixin) {
        wechatShare(() => getWxShareInfo())
      } else if (ua.QQ) {
        mqqShare(type => getQQShareInfo(type))
      }
    }
  }
})
